<template>
  <div>
    <McAlert
      v-if="quotaData"
      class="mb-4"
      :variant="quotaData.alert"
      withIcon
      :customIcon="quotaData.icon"
    >
      <template #label>
        <div>
          <p>{{ quotaData.title }}</p>
          <p class="teal-300 mb-0">{{ quotaData.message }}</p>
        </div>
      </template>
    </McAlert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import McAlert from '@/components/McAlert'

export default {
  components: { McAlert },
  props: {
    quotaStatus: {
      type: String,
      default: 'available',
    },
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    quotaData() {
      const statusMap = {
        low: {
          alert: 'warning',
          title: this.$t('routeOptimization.alert.lowQuota'),
          message: this.$t('routeOptimization.alert.lowQuotaMessage'),
          icon: 'icon-fill_alert-triangle',
        },
        empty: {
          alert: 'error',
          title: this.$t('routeOptimization.alert.emptyQuota'),
          message: this.$t('routeOptimization.alert.emptyQuotaMessage'),
          icon: 'icon-fill_alert-circle',
        },
      }
      return statusMap[this.quotaStatus] || null
    },
  },
}
</script>
